import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import { Tooltip } from "react-tooltip";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  ErrorModal,
  MessageBoxModal,
  UserAgreementModal,
} from "../../components/Common/CombinedComponents";
import RavenFormikField from "../../components/Common/RavenFormikField";
import { Card, CardBody, Col, Container, Row, Label } from "reactstrap";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as YupPassword from "yup-password";
YupPassword(Yup);
import {
  addNewCreateUserAcount,
  userDefinitionsApiError,
  getUserAgreements,
} from "../../store/actions";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { InputMask } from "primereact/inputmask";
import PhoneInput from "react-phone-input-2";
import { Password } from "primereact/password";
import 'react-phone-input-2/lib/style.css';
import { InputSwitch } from "primereact/inputswitch";
import { Message } from "primereact/message";
import errorIcon from "assets/images/alerts/error.svg";
import { Dialog } from 'primereact/dialog';

class CreateUserAcount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: "",
      modal: false,
      errorModal: false,
      approveModal: false,
      messageBoxModal: false,
      userAgreementModal: false,
      userAgreementList: [],
      email: "",
      agreement: "",
      openAgreement: null

    };

    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.props.apiError("");
    const { userAgreementList, onGetUserAgreementList } = this.props;
    onGetUserAgreementList();
    this.setState({ userAgreementList });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error, user, userAgreementList } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
    if (prevProps.user !== user) {
      this.setState({ user: user });
      this.setState({ messageBoxModal: true });
    }
    if (prevProps.userAgreementList !== userAgreementList) {
      this.setState({ userAgreementList: userAgreementList });
    }
  }

  toggle() {

    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      setTimeout(() =>
        this.setState({ messageBoxModal: false })
        , 150);
    }
  }

  handleValidRecordSubmit = (values, actions) => {
    const { user, onAddRecord, userAgreementList } = this.props;
    this.setState({ email: values.email });

    if (values.agreements.length === 0) {
      let error = {
        message: this.props.t("userAgreementChooseError"),
        code: "userAgreementChooseError",
      };
      this.setState({ errorModal: true, error: error });
      return;
    }
    if (userAgreementList !== undefined) {
      let filteredRecord = "";
      let isForced = false;
      let isAgreementForcedError = false;
      userAgreementList.forEach(item => {
        isForced = item.isForced;
        filteredRecord = values.agreements.filter(
          x => x.guid == item.guid,
        );
        if (filteredRecord.length === 0 && isForced) {
          isAgreementForcedError = true;
        }
      });

      // if (isAgreementForcedError) {
      //   let error = {
      //     message: this.props.t("userAgreementIsForcedError"),
      //     code: "userAgreementIsForcedError",
      //   };
      //   this.setState({ errorModal: true, error: error });
      //   return;
      // }
    }

    let telPhone = values.phone.replace(/\s+/g, "");
    let fullTelPhone = values.phoneCode.replace("+", "") + telPhone

    let createUserAcountVM = {
      firstName: values.firstName,
      lastName: values.lastName,
      phone: fullTelPhone,
      email: values.email,
      password: values.password,
      userAgreements: values.agreements.map(guid => ({ guid }))
    };

    onAddRecord(createUserAcountVM);
    this.setState({ user });
    this.toggle();
  };


  onLoginLinkClick = e => {
    e.preventDefault();
    this.setState({ messageBoxModal: false });
    this.props.history.push("/login");
  };

  clickHandler(e, item) {
    let el = e.target;
    while (el && el !== e.currentTarget && el.tagName !== "B") {
      el = el.parentNode;
    }
    if (el && el.tagName === "B") {
      this.setState({ agreement: item });
      this.setState({ userAgreementModal: true });
    }
  }

  renderValidationMessages = (errors, touched) => {
    const { t } = this.props;
    const { error } = this.state;

    const hasErrors = error || (Object.keys(errors).length > 0 && Object.keys(touched).length > 0);

    if (!hasErrors) return null;

    const validationMessages = Object.values(errors).flatMap((msg) => {
      if (typeof msg === "string") return [msg];
      if (Array.isArray(msg)) return msg.filter((m) => typeof m === "string");
      return [];
    });

    const requiredMsg = t("errors.required");
    const messagesToRender = validationMessages.includes(requiredMsg)
      ? [requiredMsg]
      : validationMessages;

    return (
      <Message
        severity="error"
        className="d-flex justify-content-start gap-1 mb-4"
        content={
          <>
            <img src={errorIcon} alt="error" />
            <div>
              <b>{t("common.error")}:</b>
              <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
                {messagesToRender.map((msg, idx) => (
                  <li key={`validation-${idx}`}>{msg}</li>
                ))}
                {error?.message && <li>{t(error.message)}</li>}
              </ul>
            </div>
          </>
        }
      />
    );
  };

  renderUserAgreements = (values, setFieldValue, setFieldTouched) => {
    return this.props.userAgreementList.map((item) => {
      const linkedText = item.linkedText;
      const parts = item.description?.split(linkedText);

      return (
        <div className="form-item" key={item.guid}>
          <div className="d-flex align-items-center gap-2">
            <InputSwitch
              id={`agreement-${item.guid}`}
              checked={values.agreements.includes(item.guid)}
              onChange={(e) => {
                const newValue = e.value;
                let updated = [...values.agreements];

                if (newValue) {
                  updated.push(item.guid);
                } else {
                  updated = updated.filter(g => g !== item.guid);
                }

                setFieldValue("agreements", updated);
                setFieldTouched("agreements", true, false);
              }}
            />

            <label htmlFor={`agreement-${item.guid}`} className="switch-link">
              {linkedText && parts.length > 1 ? (
                <>
                  {parts[0]}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ openAgreement: item });
                    }}
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    {linkedText}
                  </a>
                  {parts[1]}
                </>
              ) : (
                item.description
              )}
            </label>
          </div>
        </div>
      );
    });
  };

  render() {
    const { error, messageBoxModal, userAgreementModal, user, agreement } =
      this.state;
    const { userAgreementList, t } = this.props;
    function NullControl(item) {
      return item != null;
    }

    const getDescription = item => {
      if (item.linkedText) {
        const re = new RegExp(item.linkedText, "g");
        return item.description.replace(re, `<b>${item.linkedText}</b>`);
      } else {
        return item.description;
      }
    };

    return (
      <React.Fragment>
        <MessageBoxModal
          messageText={this.props.t("yourMembershipHasBeenSuccessfullyCreated")}
          messageDetailText={
            this.props.t("anActivationEmailHasBeenSentTo") +
            " " +
            this.state.email
          }
          show={messageBoxModal}
          onCloseClick={this.onLoginLinkClick}
        />
        {error && (
          <ErrorModal
            errorMessage={error}
            onCloseModalClick={() =>
              this.setState({ error: undefined, messageBoxModal: false })
            }
          />
        )}
        {
          this.state.openAgreement && (
            <Dialog
              header={this.state.openAgreement.name}
              visible={!!this.state.openAgreement}
              style={{ width: '50vw' }}
              onHide={() => this.setState({ openAgreement: null })}
            >
              <div dangerouslySetInnerHTML={{ __html: this.state.openAgreement.agreementContent }} />
            </Dialog>
          )
        }

        <ToastContainer />
        <UserAgreementModal
          title={agreement.name}
          message={agreement.agreementContent}
          show={userAgreementModal}
          onCloseClick={() => this.setState({ userAgreementModal: false })}
        />

        <Container>
          <Row className="justify-content-center">
            <div className="p-2">
              <Formik
                initialValues={{
                  firstName: "",
                  lastName: "",
                  email: "",
                  phone: "",
                  password: "",
                  passwordAgain: "",
                  phoneCode: "+90",
                  agreements: []
                }}
                validationSchema={Yup.object().shape({
                  firstName: Yup.string()
                    .strict(true)
                    .max(
                      50,
                      this.props.t("maxLengthError").format("50"),
                    )
                    .required(this.props.t("errors.required")),
                  lastName: Yup.string()
                    .strict(true)
                    .max(
                      50,
                      this.props.t("maxLengthError").format("50"),
                    )
                    .required(this.props.t("errors.required")),
                  email: Yup.string()
                    .strict(true)
                    .max(
                      50,
                      this.props.t("maxLengthError").format("50"),
                    )
                    .required(this.props.t("errors.required"))
                    .matches(
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
                      this.props.t("invalidEmail")
                    ),
                  phone: Yup.string()
                    .strict(true)
                    .required(this.props.t("errors.required")),
                  password: Yup.string()
                    .min(6, t("errors.invalidPassword"))
                    .required(t("errors.required")),
                  passwordAgain: Yup.string()
                    .oneOf([Yup.ref("password")], t("errors.passwordsMustMatch"))
                    .required(t("errors.required")),
                  agreements: Yup.array()
                    .of(Yup.string())
                    .test(
                      "all-agreements-checked",
                      t("errors.approveAllMerchantAgreements"),
                      function (value) {
                        const requiredGuids = userAgreementList.map(x => x.guid);
                        if (!value || value.length !== requiredGuids.length) return false;
                        return requiredGuids.every(guid => value.includes(guid));
                      }
                    )

                })}
                enableReinitialize={true}
                validateOnChange={true}
                validateOnBlur={true}
                validateOnMount={false}
                onSubmit={(values, actions) => {
                  this.handleValidRecordSubmit(values, actions);
                }}
              >
                {({ errors, touched, values, handleChange, handleBlur, setFieldValue, setFieldTouched }) => (
                  <Form>

                    {this.renderValidationMessages(errors, touched)}

                    <div className="form-title">{t("login.newAccount")}</div>
                    <Row>
                      <Col lg={12} className="col-12">
                        <div className="phone-input-container">
                          <div className="country-input">
                            <PhoneInput
                              country={"tr"}
                              id="phoneCode"
                              value={values.phoneCode}
                              disabled={false}
                              onChange={(phone) => (values.phoneCode = phone)}
                              buttonClass="flag-dropdown"
                              containerClass="react-tel-input"
                            />
                          </div>
                          <InputMask
                            mask="999 999 99 99"
                            placeholder="999 999 99 99"
                            id="phone"
                            name="phone"
                            value={values.phone}
                            className={`p-form-control ${errors.phone && touched.phone ? "is-invalid" : ""}`}
                            onChange={handleChange}
                            disabled={false}
                            invalid={touched.phone && errors.phone}
                          />
                        </div>
                        <div className="formik-error-placeholder"></div>
                      </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <Field
                            name="firstName"
                            type="text"
                            errors={errors}
                            className={`form-control ${errors.firstName && touched.firstName ? "is-invalid" : ""}`}
                            placeholder={t("common.firstName")}
                            onChange={(e) => {
                              setFieldValue("firstName", e.target.value);
                              this.setState({ error: null });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <Field
                            name="lastName"
                            type="text"
                            errors={errors}
                            className={`form-control ${errors.lastName && touched.lastName ? "is-invalid" : ""}`}
                            placeholder={t("common.lastName")}
                            onChange={(e) => {
                              setFieldValue("lastName", e.target.value);
                              this.setState({ error: null });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <Field
                            name="email"
                            type="email"
                            errors={errors}
                            className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                            placeholder={t("email")}
                            onChange={(e) => {
                              setFieldValue("email", e.target.value);
                              this.setState({ error: null });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <Password
                            className={`p-form-control ${errors.password && touched.password ? "is-invalid" : ""}`}
                            type="password"
                            id="password"
                            label="password"
                            name="password"
                            placeholder={t("common.password")}
                            value={values.password}
                            onChange={handleChange}
                            invalid={touched.password && errors.password}
                            feedback={false}
                            tabIndex={1}
                            toggleMask
                          />
                        </div>
                      </Col>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <Password
                            className={`p-form-control ${errors.passwordAgain && touched.passwordAgain ? "is-invalid" : ""}`}
                            type="password"
                            id="passwordAgain"
                            name="passwordAgain"
                            placeholder={t("common.passwordAgain")}
                            value={values.passwordAgain}
                            onChange={handleChange}
                            invalid={touched.passwordAgain && errors.passwordAgain}
                            feedback={false}
                            tabIndex={1}
                            toggleMask
                          />
                        </div>
                      </Col>

                      <Col lg={12} className="col-12">
                        {this.renderUserAgreements(values, setFieldValue, setFieldTouched)}
                      </Col>

                      <Col lg={12} className="col-12">
                        <div className="mt-3 d-grid">
                          <br></br>
                          <button
                            className="createAcc-button"
                            type="submit"
                            disabled={false}
                            style={{ backgroundColor: "#AB63BF", color: "#FAF3FD" }}
                          >
                            {this.props.t("continueToCreateAccount")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </Row>
        </Container>
      </React.Fragment >
    );
  }
}

CreateUserAcount.propTypes = {
  onGetUserAgreementList: PropTypes.func,
  userAgreementList: PropTypes.array,
  onAddRecord: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.any,
  t: PropTypes.any,
  user: PropTypes.any,
  agreement: PropTypes.any,
};

const mapStateToProps = ({ UserDefinition, userAgreement }) => ({
  error: UserDefinition.error,
  user: UserDefinition.user,
  userAgreementList: userAgreement.userAgreementList,
});

const mapDispatchToProps = dispatch => ({
  onGetUserAgreementList: () => dispatch(getUserAgreements()),
  onAddRecord: user => dispatch(addNewCreateUserAcount(user)),
  apiError: error => dispatch(userDefinitionsApiError(error)),
});

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(CreateUserAcount)
  )
);